/** Stores Shopify settings in sessionStorage (for the current session) */
export const setShopifyParams = (shop, host) => {
  if (host) sessionStorage.setItem('shopify_host', host);
  if (shop) sessionStorage.setItem('shopify_shop', shop);
};

/** Gets Shopify parameters from sessionStorage */
export const getShopifyParams = () => {
  const host = sessionStorage.getItem('shopify_host');
  const shop = sessionStorage.getItem('shopify_shop');

  if (!host && !shop) return null;

  return { host, shop };
};

/** Cleans Shopify settings */
export const clearShopifyParams = () => {
  sessionStorage.removeItem('shopify_host');
  sessionStorage.removeItem('shopify_shop');
};
